import React from "react";

import { LottieLoading } from "../../../../components/graphics/LottieLoading";
import { WorkTypeAutomationSection } from "../components/WorkTypeAutomationSection";
import { WorkTypeConfirmModals } from "../components/WorkTypeConfirmModals";
import { WorkTypeDetailsSection } from "../components/WorkTypeDetailsSection";
import { WorkTypeEditorHeader } from "../components/WorkTypeEditorHeader";
import { WorkTypeStatusesSection } from "../components/WorkTypeStatusesSection";
import { useWorkTypeEditorController } from "../hooks/useWorkTypeEditorController";

export const ViewWorkTypePage = () => {
  const {
    isLoading,
    headerProps,
    detailsProps,
    automationProps,
    statusesProps,
    modalProps,
  } = useWorkTypeEditorController();

  return (
    <>
      <div>
        {isLoading ? (
          <LottieLoading />
        ) : (
          <div className={"mb-72 font-Manrope"}>
            <WorkTypeEditorHeader {...headerProps} />
            <WorkTypeDetailsSection {...detailsProps} />
            <WorkTypeAutomationSection {...automationProps} />
            <WorkTypeStatusesSection {...statusesProps} />
          </div>
        )}
      </div>
      <WorkTypeConfirmModals {...modalProps} />
    </>
  );
};
